(() => {
  const selector = '[data-scroll-down]';
  const buttonScroll = document.querySelector(selector);

  if (buttonScroll) {
    buttonScroll.addEventListener("click", () => {
      smoothScroll();
    }, false);

    buttonScroll.addEventListener('keyup', event => {
      if (event.keyCode == 13) {
        smoothScroll();
      }
    }, false);
  }

  const smoothScroll = () => {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0,
      behavior: "smooth"
    });
  }

  const getPlayer = (videoId) => videojs && videojs(videoId);
  const getVideoBanner = (id) => document.querySelector('[data-banner-video="' + id + '"]');
  const bannerPlayOpeners = document.querySelectorAll('[data-play-video]:not(.ready)');

  const playVideo = (target, playButton) => {
    let playWrapper = playButton.parentElement;
    playButton.setAttribute('hidden', true);
    playButton.setAttribute('aria-hidden', true);

    if (playWrapper.classList.contains('video_banner__play_wrapper')) {
      playWrapper.remove()
    }

    target.setAttribute('aria-hidden', 'false');
    target.removeAttribute('hidden');
    target.dataset.bannerVideoId && getPlayer(target.dataset.bannerVideoId).play();
  }

  if (bannerPlayOpeners) {
    bannerPlayOpeners.forEach(item => {
      item.classList.add('ready');
      let videoBanner = getVideoBanner(item.dataset.playTarget);

      if (videoBanner !== null) {
        videoBanner.classList.add('ready');
        item.addEventListener('click', () => playVideo(videoBanner, item));
      }
    });
  }
})();
